module.exports = __webpack_public_path__ + "static/robe_of_eyes-eb746704992ede8cc6a9977d5d9b051c.jpeg";